import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { MaterialModule } from '@app/material/material.module';

import { ButtonModule } from '@shared/components/button/button.module';

import { ConfirmDialogService } from './confirm-dialog.service';

import { ConfirmDialogComponent } from './confirm-dialog.component';


@NgModule({
  imports: [
    CommonModule,
    ButtonModule,
    MaterialModule
  ],
  declarations: [ConfirmDialogComponent],
  exports: [ConfirmDialogComponent],
  entryComponents: [ConfirmDialogComponent],
  providers: [ConfirmDialogService]
})
export class ConfirmDialogModule { }
